import groq from 'groq';
import type { SiteCategory } from 'types/common/SiteCategory';

export const getPlpMenuQuery = (category: SiteCategory) => {
  const isSkincare = category === 'skincare';
  const id = isSkincare ? 'skincare_settings' : 'settings';

  return groq`
    *[_type in['timeline_settings'] && _id == "${id}"][0] {
      plpMenu[]-> {
        "slug": slug.current,
        primaryCollection {
          "products": collection -> {...}.products[].product -> {
            "slug": store.slug.current
          }
        }
      }
    }
  `;
};
